import { useWaitingBookingsApi } from '@api/demo-slots/waiting-bookings.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(() => {
  void useWaitingBookingsApi()
})
